var _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgMotivar(_ref, svgRef) {
  let title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 124,
    height: 41,
    viewBox: "0 0 124 41",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group 1"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector",
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M0 28.6809L0.0380641 40.3831H5.06271C5.29745 38.4816 5.13251 29.3681 5.15154 25.9388C5.95726 27.093 10.671 36.9271 11.0707 38.4016H14.0145C15.2199 37.5009 18.7727 27.7669 20.2826 25.8855L20.327 40.3564H25.4024C25.6308 38.2681 25.4722 19.9343 25.4722 16.3983H18.4935L12.7837 29.188C11.9082 28.1072 7.70828 18.2664 6.97869 16.3983H0V28.6809Z",
    fill: "#116653"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_2",
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M37.4376 26.2925C32.2671 27.9938 34.0181 37.8679 39.9753 36.1199C45.1967 34.5987 43.6487 24.2376 37.4376 26.2925ZM37.5582 21.7357C25.2503 23.5638 27.7944 42.2178 40.0071 40.6233C52.0358 39.0354 49.809 19.9077 37.5582 21.7224V21.7357Z",
    fill: "#116653"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_3",
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M103.767 32.4437C102.271 32.3096 100.766 32.3611 99.2814 32.5972C97.7905 33.0175 97.2132 34.5987 98.3742 35.7596C100.176 37.5609 104.401 36.1199 103.767 32.4237M93.7048 24.1108L95.7666 27.5534C97.2766 26.953 97.9618 26.0723 100.208 25.8321C102.162 25.6253 104.128 26.4459 103.646 28.6609C101.743 29.3281 98.6279 28.1805 95.792 29.5749C94.6761 30.0693 93.7746 30.982 93.2623 32.1358C92.75 33.2897 92.6635 34.6025 93.0196 35.8197C94.2187 41.0036 100.557 42.2111 104.008 38.3816L104.128 40.3831H108.696C108.988 37.8678 108.817 33.8915 108.785 31.2495C108.741 27.7469 108.95 25.8054 107.021 23.6638C105.543 22.0226 102.993 21.4154 100.246 21.6623C97.1751 21.9292 95.7666 22.9966 93.7048 24.1308V24.1108Z",
    fill: "#116653"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_4",
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M77.6792 8.94606C76.1566 8.48571 73.6887 12.2819 71.6839 8.23218C70.4912 5.83704 71.189 2.04752 69.7108 0.719849C68.1438 0.879969 67.0906 2.94822 66.4689 4.50273C65.5045 6.91788 65.0668 7.75181 62.2436 6.59761C57.847 4.80959 60.8986 13.9365 62.6242 15.8246C67.0652 20.7083 73.4095 19.6141 76.4865 14.8238C77.2457 13.5818 77.7252 12.1739 77.8885 10.7074C78.0154 9.53318 77.9774 9.44643 77.6792 8.94606Z",
    fill: "#116653"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_5",
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M79.7412 40.3697H84.7278C85.4764 38.9687 91.5225 23.0233 91.6557 21.8691H86.6565C85.1085 25.5186 83.8142 29.5216 82.336 33.131C81.2321 31.8834 79.1195 24.0041 77.895 21.8691H72.9655L79.7412 40.3697Z",
    fill: "#116653"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_6",
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M52.1563 17.5658L52.1182 21.8825L50.1198 21.9292V25.6986L52.169 25.7387C52.2515 29.6416 51.395 35.873 53.533 38.4549C56.0327 41.4839 60.0676 41.3237 62.986 38.4949L61.2413 34.9656C60.5561 35.4126 59.338 36.6469 58.0692 35.8663C56.8003 35.0857 57.1429 31.7499 57.1492 29.5549V25.752L61.3428 25.6986V21.9625L57.1239 21.9158V16.445H52.1436L52.1563 17.5658Z",
    fill: "#116653"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_7",
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M118.073 22.2293C116.804 21.8624 114.711 22.0425 113.315 22.0225L113.277 40.3096H118.035C118.035 39.3089 117.769 32.5171 118.168 32.2569C118.036 30.6877 118.458 29.1222 119.355 27.8602C120.402 26.5259 121.461 26.7261 123.326 26.4792V21.7557C121.347 21.4154 119.063 23.2901 118.251 24.1108L118.073 22.2293Z",
    fill: "#116653"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_8",
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M65.5427 40.3163L70.4468 40.3764L70.4913 21.9692L65.5935 21.9225L65.5427 40.3163Z",
    fill: "#116653"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_9",
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M118.168 32.2369C117.769 32.4971 118.035 39.2889 118.035 40.2896H113.277L113.315 22.0025C114.711 22.0025 116.798 21.8424 118.073 22.2094C117.858 21.6423 118.01 21.8491 117.122 21.8157C116.684 21.8157 116.132 21.8157 115.681 21.8157C114.835 21.7376 113.982 21.7735 113.144 21.9225L113.074 40.343C114.191 40.6232 116.925 40.5098 118.149 40.4097L118.168 32.2369Z",
    fill: "#116653"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMotivar);
export default __webpack_public_path__ + "static/media/Motivar.18579e0d2286f076865a4670f6a7c2b1.svg";
export { ForwardRef as ReactComponent };